var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _IndexedDBStrategy_instances, _IndexedDBStrategy_dbName, _IndexedDBStrategy_objectStoreName, _IndexedDBStrategy_dbVersion, _IndexedDBStrategy_withDB, _IndexedDBStrategy_withObjectStore;
import { openDB } from 'idb';
import ErrorBase from '../../exceptions/ErrorBase';
import AbstractStorageStrategy from './AbstractStorageStrategy';
import { StorageStrategyErrors } from '../StorageErrors';
class IndexedDBStrategy extends AbstractStorageStrategy {
    constructor(dbName, objectStoreName = 'object_store') {
        super();
        _IndexedDBStrategy_instances.add(this);
        _IndexedDBStrategy_dbName.set(this, void 0);
        _IndexedDBStrategy_objectStoreName.set(this, void 0);
        _IndexedDBStrategy_dbVersion.set(this, void 0);
        __classPrivateFieldSet(this, _IndexedDBStrategy_dbName, dbName, "f");
        __classPrivateFieldSet(this, _IndexedDBStrategy_objectStoreName, objectStoreName, "f");
        __classPrivateFieldSet(this, _IndexedDBStrategy_dbVersion, 1, "f");
    }
    async initialize() {
        const objectStoreName = __classPrivateFieldGet(this, _IndexedDBStrategy_objectStoreName, "f");
        const db = await openDB(__classPrivateFieldGet(this, _IndexedDBStrategy_dbName, "f"), __classPrivateFieldGet(this, _IndexedDBStrategy_dbVersion, "f"), {
            upgrade(database) {
                if (!database.objectStoreNames.contains(objectStoreName)) {
                    database.createObjectStore(objectStoreName);
                }
            }
        });
        db.close();
    }
    async getItem(key) {
        let result = null;
        await __classPrivateFieldGet(this, _IndexedDBStrategy_instances, "m", _IndexedDBStrategy_withObjectStore).call(this, 'readonly', async (objectStore) => {
            result = (await objectStore.get(key)) ?? null;
        });
        return result;
    }
    async setItem(key, value) {
        const keyExists = await this.getItem(key);
        if (keyExists) {
            throw new ErrorBase(StorageStrategyErrors.KEY_EXISTS, { key, value: value });
        }
        return __classPrivateFieldGet(this, _IndexedDBStrategy_instances, "m", _IndexedDBStrategy_withDB).call(this, async (db) => {
            await db.add(__classPrivateFieldGet(this, _IndexedDBStrategy_objectStoreName, "f"), value, key);
            return value;
        });
    }
    async updateItem(key, value) {
        const keyExists = await this.getItem(key);
        if (!keyExists) {
            throw new Error(StorageStrategyErrors.KEY_NOT_EXISTS);
        }
        return __classPrivateFieldGet(this, _IndexedDBStrategy_instances, "m", _IndexedDBStrategy_withDB).call(this, async (db) => {
            await db.put(__classPrivateFieldGet(this, _IndexedDBStrategy_objectStoreName, "f"), value, key);
            return value;
        });
    }
    async removeItem(key) {
        const db = await openDB(__classPrivateFieldGet(this, _IndexedDBStrategy_dbName, "f"), __classPrivateFieldGet(this, _IndexedDBStrategy_dbVersion, "f"));
        try {
            await db.delete(__classPrivateFieldGet(this, _IndexedDBStrategy_objectStoreName, "f"), key);
        }
        finally {
            db.close();
        }
    }
    async clear() {
        const db = await openDB(__classPrivateFieldGet(this, _IndexedDBStrategy_dbName, "f"), __classPrivateFieldGet(this, _IndexedDBStrategy_dbVersion, "f"));
        try {
            const transaction = db.transaction(__classPrivateFieldGet(this, _IndexedDBStrategy_objectStoreName, "f"), 'readwrite');
            const objectStore = transaction.objectStore(__classPrivateFieldGet(this, _IndexedDBStrategy_objectStoreName, "f"));
            await objectStore.clear();
        }
        finally {
            db.close();
        }
    }
    async key(keyIndex) {
        const db = await openDB(__classPrivateFieldGet(this, _IndexedDBStrategy_dbName, "f"), __classPrivateFieldGet(this, _IndexedDBStrategy_dbVersion, "f"));
        try {
            const transaction = db.transaction(__classPrivateFieldGet(this, _IndexedDBStrategy_objectStoreName, "f"), 'readonly');
            const objectStore = transaction.objectStore(__classPrivateFieldGet(this, _IndexedDBStrategy_objectStoreName, "f"));
            const keys = (await objectStore.getAllKeys());
            return keys[keyIndex] || null;
        }
        finally {
            db.close();
        }
    }
    async keys() {
        const db = await openDB(__classPrivateFieldGet(this, _IndexedDBStrategy_dbName, "f"), __classPrivateFieldGet(this, _IndexedDBStrategy_dbVersion, "f"));
        try {
            const transaction = db.transaction(__classPrivateFieldGet(this, _IndexedDBStrategy_objectStoreName, "f"), 'readonly');
            const objectStore = transaction.objectStore(__classPrivateFieldGet(this, _IndexedDBStrategy_objectStoreName, "f"));
            const keys = await objectStore.getAllKeys();
            return keys.map((key) => key.toString());
        }
        finally {
            db.close();
        }
    }
}
_IndexedDBStrategy_dbName = new WeakMap(), _IndexedDBStrategy_objectStoreName = new WeakMap(), _IndexedDBStrategy_dbVersion = new WeakMap(), _IndexedDBStrategy_instances = new WeakSet(), _IndexedDBStrategy_withDB = async function _IndexedDBStrategy_withDB(callback) {
    const db = await openDB(__classPrivateFieldGet(this, _IndexedDBStrategy_dbName, "f"), __classPrivateFieldGet(this, _IndexedDBStrategy_dbVersion, "f"));
    try {
        return await callback(db);
    }
    finally {
        db.close();
    }
}, _IndexedDBStrategy_withObjectStore = async function _IndexedDBStrategy_withObjectStore(mode, callback) {
    const db = await openDB(__classPrivateFieldGet(this, _IndexedDBStrategy_dbName, "f"), __classPrivateFieldGet(this, _IndexedDBStrategy_dbVersion, "f"));
    const transaction = db.transaction([__classPrivateFieldGet(this, _IndexedDBStrategy_objectStoreName, "f")], mode);
    const objectStore = transaction.objectStore(__classPrivateFieldGet(this, _IndexedDBStrategy_objectStoreName, "f"));
    await callback(objectStore, transaction);
    await transaction.done;
    db.close();
};
export default IndexedDBStrategy;
